import { render, staticRenderFns } from "./Point.vue?vue&type=template&id=7d6690ea&scoped=true&"
import script from "./Point.vue?vue&type=script&lang=js&"
export * from "./Point.vue?vue&type=script&lang=js&"
import style0 from "./Point.vue?vue&type=style&index=0&id=7d6690ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6690ea",
  null
  
)

export default component.exports